import React from 'react'
import './cer.css'
import 'bootstrap/dist/css/bootstrap.css';
import Carousel from 'react-bootstrap/Carousel';
export default function imgswitch() {
  return (
    <div className='cer'>
      {/* Images flipping */}
      <h1 style={{textAlign:'center',color:'green'}}>Our Certifications</h1>
      <div className="c1">
        <Carousel className='sliding'>
          <Carousel.Item interval={1000}>
            <img className="images" src="./fram2.png" alt="I1" />
          </Carousel.Item>
          <Carousel.Item interval={1000}>
            <img className="images" src="./frame1.png" alt="I2" />
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  )
}
